<mat-card class="empathy-card__card" [ngClass]="[style(), fullSize() ? 'full-size' : '', fitBox() ? 'fit-box' : '']" [attr.role]="'region'">
  <mat-card-content [class.no-title]="noTitle()">
    <ng-content select="[slot=content]"></ng-content>
  </mat-card-content>
</mat-card>
